<template>
  <b-card v-show="!hide" class="search-result search-result-trade">
    <div class="wl-vertical-grab-handle handle" v-if="winelist && editable">
      <svg class="bi mt-1 mb-2" fill="currentColor" width="18px" height="18px">
        <use
          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
        /></svg
      ><br />
      <b-link
        class=""
        @click="
          wlItem.hide = !wlItem.hide;
          $emit('hide', wlItem.hide);
        "
      >
        <svg class="bi mb-2" fill="currentColor" width="18px" height="18px">
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#eye-slash"
          />
        </svg> </b-link
      ><br />
      <b-link @click="$emit('remove-item')"
        ><svg class="bi mb-2" fill="currentColor" width="18px" height="18px">
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x-square"
          />
        </svg>
      </b-link>
    </div>
    <div
      class="search-result"
      :class="{
        'search-result-ib': result._source.DutyType === 'IB',
        'search-result-dp': result._source.DutyType === 'DP',
        'opacity-1': winelist && wlItem.hide,
        'has-grab-bar': winelist && editable,
      }"
    >
      <b-row no-gutter>
        <b-col cols="4" md="3" lg="2" class="text-center">
          <div
            :class="{
              'product-image': true,
              'on-offer': result._source.Promotion,
            }"
          >
            <a :href="result._source.Permalink"
              ><b-img-lazy
                :src="
                  result._source.Images &&
                  result._source.Images.length > 0 &&
                  result._source.Images[0]
                    ? result._source.Images[0]
                    : '/app/themes/jeroboams-2020/resources/assets/images/product-placeholder-low.png'
                "
                fluid
                alt="Product image"
              ></b-img-lazy
            ></a>
          </div>
        </b-col>
        <b-col cols="8" md="9" lg="10">
          <b-row>
            <b-col>
              <h5>
                <a :href="result._source.Permalink">
                  {{ result._source.ItemDescription[0] }}
                </a>
              </h5>
            </b-col>
            <b-col cols="12" lg="4" class="text-left text-lg-right">
              <wine-list-add-product
                v-if="!winelist"
                :sku="result._id"
              ></wine-list-add-product>
            </b-col>
          </b-row>

          <div
            class="product-description mb-2"
            v-html="
              $options.filters.truncate(result._source.ProductDescription, 280)
            "
          ></div>

          <div
            class="mixed-case-parents mb-2"
            v-if="result._source.ParentCases || result._source.Promotions"
          >
            <div
              v-for="(parentCase, index) in result._source.ParentCases"
              :key="index"
              class="mixed-case-label d-inline"
            >
              <a :href="parentCase.url">{{ parentCase.name }}</a>
            </div>

            <div
              v-for="(promotion, index) in result._source.Promotions"
              :key="index"
              class="mixed-case-label d-inline"
              :style="{
                color: promotion.fg,
                backgroundColor: promotion.bg,
              }"
            >
              <a :href="promotion.url" :style="{ color: promotion.fg }">{{
                promotion.text
              }}</a>
            </div>
          </div>

          <b-row>
            <b-col>
              <div class="product-key-info mb-1 d-none d-lg-block">
                <product-colour
                  class="float-left mb-1"
                  :result="result"
                ></product-colour>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <product-hierarchy
                @set-filter="$emit('set-filter', $event)"
                :result="result"
              ></product-hierarchy>
            </b-col>
            <b-col class="text-right product-key-info" size="2">
              <b-link v-b-toggle="'technical-info-' + result._id">
                <span class="when-open">Hide</span
                ><span class="when-closed">Show</span> technical details
              </b-link>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="d-lg-none" size="12" lg="10" offset-lg="2">
          <div class="product-key-info mb-1">
            <product-colour
              class="float-left mb-1"
              :result="result"
            ></product-colour>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="2">
          <product-technical-info
            class="mt-2"
            :result="result"
          ></product-technical-info>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import Config from "@/config/default.config.js";
import ProductColour from "@/components/ProductColour";
import ProductHierarchy from "@/components/ProductHierarchy";
import ProductTechnicalInfo from "@/components/ProductTechnicalInfo";
import WineListAddProduct from "@/components/winelist/WineListAddProduct";

import { BadgePlugin } from "bootstrap-vue";
import Vue from "vue";

import Axios from "axios";

Vue.use(BadgePlugin);

export default {
  components: {
    ProductColour,
    ProductHierarchy,
    ProductTechnicalInfo,
    WineListAddProduct,
  },
  data() {
    return {
      formatsLoading: false,
      formats: {},
    };
  },
  props: {
    result: Object,
    wlItem: {
      type: [Object, Boolean],
      default: false,
    },
    filters: Object,
    winelist: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async getFormats(result) {
      var formats = await Axios.get(
        Config.wp.host + "/jbs/v1/get-formats/" + result._source.WCID
      );

      this.formats[result._id] = formats.data;
      for (var i in this.formats[result._id]) {
        this.formats[result._id][i]._source._add_qty = 1;
      }
      this.formatsLoading = false;

      return;
    },
    toggleFormats(result) {
      if (this.formats[result._id]) {
        delete this.formats[result._id];
        this.formatsLoading = false;
        this.$forceUpdate();
      } else {
        this.formats[result._id] = false;
        this.formatsLoading = true;
        this.getFormats(result);
      }
    },
  },
};
</script>